import { PacketIn } from "./PacketIn.js";
import { InboundPacketType } from "./InboundPacketType.js";
import type { MessageIOContext } from "../../../api/MessageIOContext.js";
import { readJsonArray, readJsonBool, readJsonString } from "../../../../util/json.js";
import type { APIEarnedAchievement } from "../../../api/api_schema.js";


export class PacketInEarnedAchievements extends PacketIn {
    public achievements: APIEarnedAchievement[] = [];

    constructor() {
        super(InboundPacketType.EARNED_ACHIEVEMENTS);
    }

    override readContents(_context: MessageIOContext, json: Record<string, any>): void {
        const achievementsArray = readJsonArray(json, "achievements");
        this.achievements = achievementsArray.map((achievementJson: Record<string, any>) => {
            return {
                already_earned: readJsonBool(achievementJson, "already_earned"),
                should_notify: readJsonBool(achievementJson, "should_notify"),
                achievement_id: readJsonString(achievementJson, "achievement_id"),
                earned_at: readJsonString(achievementJson, "earned_at"),
            };
        });
    }
}
